import { render, staticRenderFns } from "./RecyclerDataTable.vue?vue&type=template&id=2fe0a362&scoped=true"
import script from "./RecyclerDataTable.vue?vue&type=script&lang=js"
export * from "./RecyclerDataTable.vue?vue&type=script&lang=js"
import style0 from "./RecyclerDataTable.vue?vue&type=style&index=0&id=2fe0a362&prod&scoped=true&lang=css"
import style1 from "./RecyclerDataTable.vue?vue&type=style&index=1&id=2fe0a362&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0a362",
  null
  
)

export default component.exports